"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ENGINEERING_PANEL_TEAM_TYPES = void 0;
const ENGINEERING_PANEL_TEAM_TYPES = exports.ENGINEERING_PANEL_TEAM_TYPES = {
  COMMAND: 'COMMAND',
  ENGINEERING: 'ENGINEERING',
  MEDICAL: 'MEDICAL',
  SECURITY: 'SECURITY',
  IT: 'IT',
  OPERATIONS: 'OPERATIONS',
  SCIENCE: 'SCIENCE',
  FLIGHT_DIRECTOR: 'FLIGHT_DIRECTOR'
};